// BattleOps design tokens — single source of truth for the app's visual language.
// The BattleSuite palette (battlebooks-mobile/src/constants/theme.ts): brand red + gold on a
// tonal warm charcoal. Organized into semantic
// scales (per the ui-ux-pro-max spec): color roles, an 8pt spacing scale, radii, a type
// scale, and elevation. Import this instead of hardcoding hex/spacing in screens.

export const color = {
  // Surfaces (darkest → lightest)
  bg: '#17120F',          // app background
  surface: '#221C18',     // cards
  surfaceAlt: '#2A231E',  // raised/active card, inputs-on-card
  input: '#2E2621',       // input fields
  border: '#352C26',      // hairline dividers, card borders
  borderStrong: '#453A32',// input borders, stronger separators

  // Text (brightest → faintest)
  text: '#FBF6EE',        // primary
  textSecondary: '#B9AD9F',
  textTertiary: '#A0958A',
  textFaint: '#7D7268',
  onAccent: '#FFFFFF',

  // Semantic
  accent: '#FB5446',      // primary action (brand red)
  accentHover: '#E23A2C',
  gold: '#FFD23F',
  accentSoft: 'rgba(251,84,70,0.14)',
  success: '#16B47A',
  successSoft: 'rgba(22,180,122,0.14)',
  warning: '#FFD23F',
  warningSoft: 'rgba(255,210,63,0.14)',
  danger: '#F0555A',
  dangerSoft: 'rgba(229,72,77,0.13)',
  purple: '#8B5CF6',

  // Scrims
  scrim: 'rgba(0,0,0,0.6)',
};

// 8pt-based spacing scale (4 for tight optical gaps).
export const space = { xs: 4, sm: 8, md: 12, lg: 16, xl: 20, xxl: 24, xxxl: 32 };

export const radius = { sm: 8, md: 12, lg: 16, xl: 20, pill: 999 };

// Modular type scale (12 14 15 17 20 24 30) + weights/letter-spacing helpers.
export const font = {
  size: { xs: 11, sm: 12, label: 13, body: 14, md: 15, lg: 17, xl: 20, xxl: 24, hero: 30 },
  weight: { regular: '400', medium: '500', semibold: '600', bold: '700', heavy: '800' },
  // Tabular figures for any numeric/time/money value, to stop layout shift.
  tabular: { fontVariant: ['tabular-nums'] },
};

// Elevation presets (RN cross-platform: iOS shadow* + Android elevation).
export const elevation = {
  card: {
    shadowColor: '#000', shadowOffset: { width: 0, height: 4 }, shadowOpacity: 0.25, shadowRadius: 12, elevation: 4,
  },
  raised: {
    shadowColor: '#000', shadowOffset: { width: 0, height: 8 }, shadowOpacity: 0.4, shadowRadius: 16, elevation: 12,
  },
  // Accent glow under the FAB.
  fab: {
    shadowColor: '#FB5446', shadowOffset: { width: 0, height: 6 }, shadowOpacity: 0.45, shadowRadius: 14, elevation: 12,
  },
};

// Motion durations (ms) — 150–250 for micro-interactions, exit faster than enter.
export const motion = { fast: 150, base: 200, slow: 280 };

export default { color, space, radius, font, elevation, motion };
